// src/data/serumsImg/antiAgingImages.js

export const antiAgingImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages_Anti-Aging.png"),
  imgModal: require("../../img/jetCare-serums/Anti-Aging_Set.png"),
  productsImages: {
    "wide-range-hyaluronic-acid": {
      image: require("../../img/jetCare-serums/Anti-Aging_WHA.10.png"),
      imageBig: require("../../img/jetCare-serums/Wide Range Hyaluronic Acid.png"),
    },
    "witch-hazel-peptides": {
      image: require("../../img/jetCare-serums/Anti-Aging_WHP.9.png"),
      imageBig: require("../../img/jetCare-serums/Anti-Aging_witch_hazel.png"),
    },
    "peptide-complex": {
      image: require("../../img/jetCare-serums/Anti-Aging_PC.8.png"),
      imageBig: require("../../img/jetCare-serums/peptide_complex.png"),
    }
  }
};
